export enum Channel {
  OrgIncidents = 'OrgIncidentsChannel',
  OrgDeviceState = 'Organizations::DevicesChannel',
  OrgDeviceCommandsState = 'DeviceCommandsChannel',
  DeviceIncidents = 'DeviceIncidentsChannel',
  DeviceCommandsChannel = 'DeviceCommandsChannel',
}
